import client from "./client";

export const subscribeAndSetToken = async (data) => {
  return await client({
    url: `/fcm/subscribe`,
    method: "post",
    data,
  });
};
